import { createActions } from "../../helpers/utils/createActions";
import { LOGO } from "./actionTypes";

export const getListaLogo = createActions(LOGO.GET_LISTA_LOGO);
export const getLogo = createActions(LOGO.GET_LOGO);
export const saveLogo = createActions(LOGO.SAVE_LOGO);
export const getLogoHistory = createActions(LOGO.GET_LOGO_HISTORY);
export const getLogoHistoryList = createActions(LOGO.GET_LOGO_HISTORY_LIST);
export const getLogoAll = createActions(LOGO.GET_LOGO_ALL);

export const loadEmptyLogo = () => ({ type: LOGO.LOAD_EMPTY_LOGO });
export const cleanMessageLogo = () => ({
  type: LOGO.CLEAN_MESSAGE_LOGO,
});
export const changePageSizeLogo = (payload) => ({ type: LOGO.CHANGE_PAGE_SIZE_LOGO, payload });